import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import './styles/main.scss'
import '@/components/base/index'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.config.productionTip = false

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAevWw0ngNYW3A9NV2usuHwUb6-s0lFT7I',
    libraries: 'places'
  }
})

new Vue({
  router,
  store,
  render: function(h) {
    return h(App)
  }
}).$mount('#app')
